export default "__VITE_ASSET__BNE$ZvJf__"